/// <reference path="./notificationSetting.base.section.ts" />

module Meevo.Plugins.NotificationSetting {
    "use strict";

    export class ClientAppointmentsSection extends NotificationSettingBaseSection {

        public isRescheduleEnabledSetting: any;
        public allowRescheduleWithinHoursSetting: any;
        public isCancellationEnabledSetting: any;
        public allowCancellationWithinHoursSetting: any;
        public defaultCancellationReasonIdSetting: any;

        public isCheckInEnabledSetting: any;

        constructor(
            protected isApplicationModeCO: boolean,
            protected isSingleLocation: boolean,
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            noun: Meevo.Model.NounEnum = null,
            identityService: Components.Common.IIdentityService = null,
            sectionSecurityKey?: string
        ) {
            super(isApplicationModeCO, isSingleLocation, sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, noun, identityService, sectionSecurityKey);
        }

        public activate(): void {
            super.activate();

            if (this.model && this.model.communicationTypeNotifications) {
                var clientApptConfirm: any = _.findWhere(this.model.communicationTypeNotifications, { communicationType: 1795, communicationTypeUser: 2088 });
                if (clientApptConfirm && clientApptConfirm.options) {
                    if (clientApptConfirm.options.isCancellationEnabled && clientApptConfirm.options.defaultCancellationReasonId) {
                        this.dataService
                            .customMethodData("api/CancellationType/" + clientApptConfirm.options.defaultCancellationReasonId, "GET", {})
                            .then((response) => {
                                clientApptConfirm.options.defaultCancellationReason = response.data;
                            });
                    }

                    if (clientApptConfirm.options.settings) {
                        this.isCancellationEnabledSetting = _.findWhere(clientApptConfirm.options.settings, { displayName: "IsCancellationEnabled" });
                        this.setCurrentAndParentLevel(this.isCancellationEnabledSetting, true);
                        clientApptConfirm.options.isCancellationEnabled = this.isCancellationEnabledSetting.currentLevel;

                        this.allowCancellationWithinHoursSetting = _.findWhere(clientApptConfirm.options.settings, { displayName: "AllowCancellationWithinHours" });
                        this.setCurrentAndParentLevel(this.allowCancellationWithinHoursSetting);
                        this.defaultCancellationReasonIdSetting = _.findWhere(clientApptConfirm.options.settings, { displayName: "DefaultCancellationReasonId" });
                        this.setCurrentAndParentLevel(this.defaultCancellationReasonIdSetting);

                        this.isRescheduleEnabledSetting = _.findWhere(clientApptConfirm.options.settings, { displayName: "IsRescheduleEnabled" });
                        this.setCurrentAndParentLevel(this.isRescheduleEnabledSetting, true);
                        clientApptConfirm.options.isRescheduleEnabled = this.isRescheduleEnabledSetting.currentLevel;

                        this.allowRescheduleWithinHoursSetting = _.findWhere(clientApptConfirm.options.settings, { displayName: "AllowRescheduleWithinHours" });
                        this.setCurrentAndParentLevel(this.allowRescheduleWithinHoursSetting);
                    }
                }

                var clientApptCheckIn: any = _.findWhere(this.model.communicationTypeNotifications, { communicationType: 11045056, communicationTypeUser: 2088 });
                if (clientApptCheckIn && clientApptCheckIn.options.settings) {
                    this.isCheckInEnabledSetting = _.findWhere(clientApptCheckIn.options.settings, { displayName: "IsCheckInEnabled" });
                    this.setCurrentAndParentLevel(this.isCheckInEnabledSetting, true);
                    clientApptConfirm.options.isCheckInEnabled = this.isCheckInEnabledSetting.currentLevel;
                }
            }
        }

        private setCurrentAndParentLevel(data: any, isBoolean: boolean = false) {
            if (this.isApplicationModeCO) {
                if (!this.model.businessType_TId || this.model.businessType_TId == null || Guid.empty.equals(this.model.businessType_TId)) {
                    data.currentLevel = isBoolean ? (data.metadata.tenantValue == "1") : data.metadata.tenantValue;
                    data.parentLevel = isBoolean ? data.metadata.isEnable : data.metadata.tenantValue;
                }
                else {
                    data.currentLevel = isBoolean ? (data.metadata.businessTypeValue == "1") : data.metadata.businessTypeValue;
                    data.parentLevel = isBoolean ? (data.metadata.tenantValue == "1") : data.metadata.tenantValue;
                }
            }
            else {
                data.currentLevel = isBoolean ? (data.metadata.locationValue == "1") : data.metadata.locationValue;
                data.parentLevel = isBoolean ? ((this.isSingleLocation && data.metadata.isEnable) || (data.metadata.businessTypeValue == "1" && data.metadata.tenantValue == "1")) : data.metadata.businessTypeValue;
            }
        }

    }
}